import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import HomePage from "./pages/HomePage";
import RoleLogin from "./pages/RoleLogin";
import CustomerSignup from "./pages/CustomerSignup";
import CustomerAccount from "./pages/CustomerAccount";
import StaffDashboard from "./pages/StaffDashboard";
import OwnerDashboard from "./pages/OwnerDashboard";
import ReceptionDashboard from "./pages/ReceptionDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangeRequestApprove from "./pages/ChangeRequestApprove";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Customer */}
            <Route path="/login" element={<RoleLogin role="customer" />} />
            <Route path="/signup" element={<CustomerSignup />} />
            <Route path="/account" element={<CustomerAccount />} />
            <Route path="/customer" element={<CustomerAccount />} />
            <Route path="/customer/login" element={<RoleLogin role="customer" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Staff (Agent) */}
            <Route path="/staff/login" element={<RoleLogin role="agent" />} />
            <Route path="/staff" element={<StaffDashboard />} />

            {/* Reception */}
            <Route path="/reception/login" element={<RoleLogin role="receptionist" />} />
            <Route path="/reception" element={<ReceptionDashboard />} />

            {/* Owner */}
            <Route path="/admin-owner/login" element={<RoleLogin role="owner" />} />
            <Route path="/admin-owner" element={<OwnerDashboard />} />
            <Route path="/owner/login" element={<RoleLogin role="owner" />} />
            <Route path="/owner" element={<OwnerDashboard />} />

            {/* Admin */}
            <Route path="/admin/login" element={<RoleLogin role="admin" />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/approve/:token" element={<ChangeRequestApprove />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
